var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowDownicon = function SvgArrowDownicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.6 0h.8c.22 0 .4.18.4.4v12.936l3.552-3.56a.4.4 0 0 1 .568 0l.56.568a.4.4 0 0 1 0 .568l-4.904 4.912a.6.6 0 0 1-.424.176h-.304a.616.616 0 0 1-.424-.176L2.52 10.912a.4.4 0 0 1 0-.568l.568-.568a.392.392 0 0 1 .56 0l3.552 3.56V.4c0-.22.18-.4.4-.4Z"
  })));
};
export default SvgArrowDownicon;